export default function getRandomElements(array, count) {
  const copy = [...array];
  // Shuffle the copied array
  const shuffled = copy.sort(() => 0.5 - Math.random());
  // Return the first `count` elements
  return shuffled.slice(0, count);
}

// "1204" -> "1,204"
export const formatCount = (n) => new Intl.NumberFormat("en-US").format(n);

// "1200000" -> "1.2M"
export const formatCompact = (n) =>
  new Intl.NumberFormat("en-US", {
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(n);
